import { render, staticRenderFns } from "./MatchResult.vue?vue&type=template&id=0e20c5cf&scoped=true"
import script from "./MatchResult.vue?vue&type=script&lang=js"
export * from "./MatchResult.vue?vue&type=script&lang=js"
import style0 from "./MatchResult.vue?vue&type=style&index=0&id=0e20c5cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20c5cf",
  null
  
)

export default component.exports